import React, { useEffect, useState } from 'react';

import { Box, TextField } from '@mui/material';

import { RuleCondition } from '~/consts/agentHub';

interface Props {
  setCreatedConditions: (condition: RuleCondition, replace?: boolean) => any;
  existingConditions: RuleCondition['value'];
}

function AgentHubCommissionsMarginInput({ setCreatedConditions, existingConditions }: Props) {
  const [margin, setMargin] = useState<number>((existingConditions?.[0]?.value as number) || 0);

  useEffect(() => {
    setCreatedConditions(
      {
        type: 'margin',
        value: [{ label: 'Margin', value: margin }],
      },
      true,
    );
  }, [margin, setCreatedConditions]);

  return (
    <Box>
      <TextField
        name="Margin"
        value={margin}
        onChange={(e) => {
          setMargin(parseInt(e.target.value, 10) || 0);
        }}
        InputProps={{ inputProps: { min: 0, max: 100 }, sx: { borderRadius: 0.5 } }}
        label="Margin"
        type="number"
        fullWidth
      />
    </Box>
  );
}

export default AgentHubCommissionsMarginInput;
